<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>Holiday</li>
  </ul>
  <section class="card">
  
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Holiday </strong>
      </span>
      <span style="float: right">
        <button class="btn btn-sm btn-primary" type="button" data-target="#holidayDialog"
          (click)="showAddPopUp()"
          [appHasPermission]="{'Url': '/holiday/edit?goveva=true&email=', 'method':'put', 'menu': 'Holiday'}">
          <i class="fa fa-plus"></i>&nbsp;Add Holiday</button>
      </span>
    </div>
    <div class="card-header">
      <div class="row">
        
        <div class="col-md-5">
          <ul class="list-inline calenderList bottomAdjuset">
            <li>
              <label class="form-control-label">Global / Company Specific</label>
            </li>
            <li>
              <div class="md-radio md-radio-inline">
                <input id="IsGlobalYesweek" type="radio" [formControl]="weeklyMasterForm.controls['IsGlobalweekly']"
                  name="IsGlobalweekly" value="Global" class="form-check-input">
                <label for="IsGlobalYesweek">Global</label>
              </div>
            </li>
            <li>
              <div class="md-radio md-radio-inline">
                <input id="IsGlobalNoweek" type="radio" [formControl]="weeklyMasterForm.controls['IsGlobalweekly']"
                  name="IsGlobalweekly" value="Company Specific" class="form-check-input">
                <label for="IsGlobalNoweek">Company Specific</label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="row mt-4"></div>
      <div class="row">
        <div class="col-md-2">
          <span class="cat__core__title">
            <h5> Weekly Off </h5>
          </span>
        </div>
        <div class="col-md-8">
          <ul class="list-inline calenderList bottomAdjuset">
            <li>
              <div class="md-checkbox">
                <input id="chkWklyMonday" type="checkbox" [disabled]="dsblMonday" (click)="ValidateWeeklyOff($event)"
                  [formControl]="weeklyMasterForm.controls['Monday']" [checked]="chkMondayFlag">
                <label for="chkWklyMonday">Monday</label>
              </div>
            </li>
            <li>
              <div class="md-checkbox">
                <input id="chkWklyTuesday" type="checkbox" [disabled]="dsblTuesday" (click)="ValidateWeeklyOff($event)"
                  [formControl]="weeklyMasterForm.controls['Tuesday']" [checked]="chkTuesdayFlag">
                <label for="chkWklyTuesday">Tuesday</label>
              </div>
            </li>
            <li>
              <div class="md-checkbox">
                <input id="chkWklyWednesday" type="checkbox" [disabled]="dsblWednesday"
                  (click)="ValidateWeeklyOff($event)" [formControl]="weeklyMasterForm.controls['Wednesday']"
                  [checked]="chkWednesdayFlag">
                <label for="chkWklyWednesday">Wednesday</label>
              </div>
            </li>
            <li>
              <div class="md-checkbox">
                <input id="chkWklyThursday" type="checkbox" [disabled]="dsblThursday" (click)="ValidateWeeklyOff($event)"
                  [formControl]="weeklyMasterForm.controls['Thursday']" [checked]="chkThursdayFlag">
                <label for="chkWklyThursday">Thursday</label>
              </div>
            </li>
            <li>
              <div class="md-checkbox">
                <input id="chkWklyFriday" type="checkbox" [disabled]="dsblFriday" (click)="ValidateWeeklyOff($event)"
                  [formControl]="weeklyMasterForm.controls['Friday']" [checked]="chkFridayFlag">
                <label for="chkWklyFriday">Friday</label>
              </div>
            </li>
            <li>
              <div class="md-checkbox">
                <input id="chkWklySaturday" type="checkbox" [disabled]="dsblSaturday" (click)="ValidateWeeklyOff($event)"
                  [formControl]="weeklyMasterForm.controls['Saturday']" [checked]="chkSaturdayFlag" (change)="changeOtherSaturdayValue()">
                <label for="chkWklySaturday">Saturday</label>
              </div>
            </li>
            <li>
              <div class="md-checkbox">
                <input id="chkWklySunday" type="checkbox" [disabled]="dsblSunday" (click)="ValidateWeeklyOff($event)"
                  [formControl]="weeklyMasterForm.controls['Sunday']" [checked]="chkSundayFlag">
                <label for="chkWklySunday">Sunday</label>
              </div>
            </li>
  
          </ul>
        </div>
        
        <div class="col-md-2">
          <span>
            <button class="btn btn-sm btn-primary" type="button" (click)="updateWeeklyOff()"
              [appHasPermission]="{'Url': '/holiday/edit?goveva=true&email=', 'method':'put', 'menu': 'Holiday'}">
              <i class="fa fa-save"></i>&nbsp;Save</button>
          </span>
        </div>
      </div>
      <div class="row">
        <div *ngIf="weeklyValidationAlert" class="form-control-error-custom">
          Only two days can be selected as weekly off.
        </div>
      </div>
      <div class="row mt-4"></div>
      <div class="row">
        <div class="col-md-2">
          <span class="cat__core__title">
            <h5> Specific Saturdays Off: </h5>
          </span>
        </div>
        <div class="col-md-8">
          <span class="cat__core__title">
            <h5> Input date range for setting up the 2nd and 4th Saturday: </h5>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <ul class="list-inline calenderList bottomAdjuset">
            <li>
              <div class="md-checkbox">
                <input id="2ndSaturday" type="checkbox" (change)="changeNormalSaturdayValue()"
                [(ngModel)]="specialSaturday" [checked]="specialSaturday">
                <label for="2ndSaturday">2nd/4th Saturday</label>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <div class="form-group" (click)="$event.stopPropagation()">
            <div class="input-group">
              <label>From: </label>
              <input class="form-control" [(ngModel)]="specialSaturdayFromDate"
                (click)="a.toggle();" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                name="dpIncorporation" ngbDatepicker #a="ngbDatepicker" (document:click)="a.close()">
              <button class="input-group-addon" (click)="a.toggle()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group" (click)="$event.stopPropagation()">
            <div class="input-group">
              <label>To: </label>
              <input class="form-control" [(ngModel)]="specialSaturdayToDate"
                (click)="a1.toggle();" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                name="dpIncorporation1" ngbDatepicker #a1="ngbDatepicker" (document:click)="a1.close()">
              <button class="input-group-addon" (click)="a1.toggle()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <span>
            <button class="btn btn-sm btn-primary" type="button" (click)="generateSaturdayOff()" [disabled]="specialSaturday == null || specialSaturday == false || specialSaturdayFromDate == undefined || specialSaturdayToDate== undefined"
              [appHasPermission]="{'Url': '/holiday/edit?goveva=true&email=', 'method':'put', 'menu': 'Holiday'}">
              <i class="fa fa-save"></i>&nbsp;Save & Display</button>
          </span>
        </div>
      </div>
  
  
    </div>
  
  
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
  
            <div class="table-responsive mb-5">
              <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap stripe"
                id="holidayTable" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Holiday Date </th>                  
                    <th>Description </th>
                    <th>Holiday Type </th>
                    <th><span [appHasPermission]="{'Url': '/holiday/edit?goveva=true&email=', 'method':'put', 'menu': 'Holiday'}">Action</span></th>
                  </tr>
                </thead>
  
                <tbody>
                  <tr *ngFor="let holiday of holidays;">
                    <td tabindex="1"><span style="display: none">{{holiday.HolidayDate | date : "yMMdd"}}</span>{{holiday.HolidayDate | date : "dd-MM-y" }}</td>
                    <td tabindex="1">{{holiday.Description }}</td>
                    <td tabindex="1">
                      <span class="badge badge-primary" *ngIf="holiday.HolidayTypeNational">National</span>
                      <span class="badge badge-success" *ngIf="holiday.HolidayTypeCompany">Company</span>
                      <span class="badge badge-default" *ngIf="holiday.HolidayTypeStockExchange">Stock Exchange</span>
                      <span class="badge badge-danger" *ngIf="holiday.HolidayTypeStockExchange !=true && holiday.HolidayTypeCompany !=true && holiday.HolidayTypeNational !=true">Not Define</span>
                    </td>
                    <td style='white-space: nowrap'>
                      <button type="button" class="btn-sm btn btn-warning" (click)="loadHolidayToEdit(holiday._id)" [appHasPermission]="{'Url': '/holiday/edit?goveva=true&email=', 'method':'put', 'menu': 'Holiday'}">
                        <span class="fa fa-pencil"></span>
                      </button>&nbsp;&nbsp;&nbsp;
                      <button type="button" class="btn-sm btn btn-danger" (click)="deleteConfirmation(holiday._id)" [appHasPermission]="{'Url': '/holiday/edit?goveva=true&email=', 'method':'put', 'menu': 'Holiday'}">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table> -->
  
              <table datatable [dtOptions]="dtOptions2" id="holidayDataTable"
                class="table table-hover compact cell-border nowrap stripe">
              </table>
  
            </div>
  
            <div class="modal fade modal-size-medium" id="holidayDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <form [formGroup]="holidayMasterForm" class="well">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="holidayModalLabel">Holiday</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-4">
                          <label class="form-control-label" for="l0">Holiday Description
                            <span _ngcontent-c2="" style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <input [formControl]="holidayMasterForm.controls['Description']" class="form-control">
                            <div *ngIf="holidayMasterForm.controls['Description'].hasError('required') && holidayMasterForm.controls['Description'].touched &&
                            holidayMasterForm.controls['Description'].hasError('whitespace')"
                              class="form-control-error-custom">
                              Holiday Description is required.
                            </div>
  
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <label class="form-control-label" for="l0">Holiday Type
                            <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <ul class="list-inline calenderList bottomAdjuset">
                              <!-- <li>
                                <div class="md-checkbox">
                                  <input id="chkNational" type="checkbox" [formControl]="holidayMasterForm.controls['National']" [checked]="chkNationalFlag">
                                  <label for="chkNational">National</label>
                                </div>
                              </li> -->
                              <li>
                                <div class="md-checkbox">
                                  <input id="chkCompany" type="checkbox"
                                    [formControl]="holidayMasterForm.controls['Company']" [checked]="chkCompanyFlag">
                                  <label for="chkCompany">Company</label>
                                </div>
                              </li>
                              <li>
                                <div class="md-checkbox">
                                  <input id="chkStockExchange" type="checkbox"
                                    [formControl]="holidayMasterForm.controls['StockExchange']"
                                    [checked]="chkStockExchangeFlag">
                                  <label for="chkStockExchange">Stock Exchange</label>
                                </div>
                              </li>
                            </ul>
                            <!-- <select class="form-control" [formControl]="holidayMasterForm.controls['HolidayType']" style="padding:6px;" aria-placeholder="Select holiday">
                              <option *ngFor="let holidayTypesList of holidayTypes" [value]="holidayTypesList.name">{{holidayTypesList.name}}</option>
                            </select> 
                            <div *ngIf="holidayMasterForm.controls['HolidayType'].hasError('required') && holidayMasterForm.controls['HolidayType'].touched"
                              class="form-control-error-custom">
                              Holiday type is required.
                            </div>-->
  
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
                        <div class="col-md-4">
                          <label class="form-control-label">Global / Company Specific</label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <div class="md-radio md-radio-inline" style="margin-left:10px;">
                              <input id="IsGlobalYes" type="radio" [formControl]="holidayMasterForm.controls['IsGlobal']"
                                name="IsGlobal" value="Global" class="form-check-input">
                              <label for="IsGlobalYes">Global</label>
                            </div>
                            <div class="md-radio md-radio-inline">
                              <input id="IsGlobalNo" type="radio" [formControl]="holidayMasterForm.controls['IsGlobal']"
                                name="IsGlobal" value="Company Specific" class="form-check-input">
                              <label for="IsGlobalNo">Company Specific</label>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
                        <div class="col-md-4">
                          <label class="form-control-label" for="l0">Holiday Date
                            <span _ngcontent-c2="" style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-8">
                          <div class="form-group">
                            <div class="input-group" (click)="$event.stopPropagation()" (document:click)="d.close();">
                              <input [formControl]="holidayMasterForm.controls['HolidayDate']" class="form-control"
                                [(ngModel)]="holidayDate" placeholder="dd-mm-yyyy" name="dp" ngbDatepicker
                                #d="ngbDatepicker" (focus)="d.toggle()">
                              <button class="input-group-addon" (click)="d.toggle()" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                              <!--[minDate]="todayDate"-->
                              <!-- <div class="input-group">
                                <input type="text" class="form-control" placeholder="Recipient's username" aria-describedby="basic-addon2">
                                <span class="input-group-addon" id="basic-addon2">@example.com</span>
                              </div> -->
                            </div>
                            <div
                              *ngIf="holidayMasterForm.controls['HolidayDate'].hasError('required') && holidayMasterForm.controls['HolidayDate'].touched"
                              class="form-control-error-custom">
                              Holiday Date is required.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button id="btnsaveHoliday" type="button" class="btn btn-sm btn-primary"
                        [disabled]="!holidayMasterForm.valid" (click)="addHoliday()">
                        <i class="fa fa-save"></i>&nbsp;Save
                      </button>
                      <button id="btnupdateHoliday" style="display:none;" type="button" class="btn btn-sm btn-primary"
                        [disabled]="!holidayMasterForm.valid" (click)="editHoliday()">
                        <i class="fa fa-save"></i>&nbsp;Update
                      </button>
                      <button type="button" class="btn btn-sm" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
  
  
            <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static"
              data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="holidayModalLabelForDelete">
                      <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                        Are you sure you want to delete the Holiday?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteHoliday()">
                      <i class="fa fa-check"></i>&nbsp;Yes
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                      <i class="fa fa-times"></i>&nbsp;No
                    </button>
                  </div>
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-alert></app-alert>